import { propagateAuthToken } from './utils/auth'
import { bootService } from 'shared/boot';

bootService('seller');

propagateAuthToken();
